import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import "./transportpiechartstyle.css";

import SedanImage from "../../../assets/TransPortManagerdashboardicons/SedanImage.webp";
import urbaniaImg from "../../../assets/TransPortManagerdashboardicons/urbania.webp";

import tempoTravellerimage from "../../../assets/TransPortManagerdashboardicons/tempoTravellerimage.webp";
import suvImg from "../../../assets/TransPortManagerdashboardicons/suvImg.webp";

ChartJS.register(ArcElement, Tooltip, Legend);

const TransportDoughnutChart = ({ salesReport }) => {
  const distribution = salesReport?.data?.transport_graph?.vehicle_distribution || [];
  const totalCurrentMonth = salesReport?.data?.transport_graph?.current_month_bookings;
  const vehicles = distribution.map((item) => ({
    label: item.vehicle_group,
    value: Number(item.current_month_bookings_count) || 0,
  }));


  const COLOR_MAP = {
    "Tempo Traveller": "#FFE500",
    Sedan: "#FFA34D",
    SUV: "#28C76F",
    Urbania: "#56CCF2",
  };

  const IMAGE_MAP = {

    Sedan: SedanImage,
    
    SUV: suvImg,
    "Tempo Traveller": tempoTravellerimage,
    Urbania: urbaniaImg,
  };

  const LABEL_MAP = {

    Sedan: "Sedan",
    SUV: "SUV",
    TempoTraveller: "Tempo Traveller",
    Urbania: "Urbania",
  };

  const dataSource = vehicles.map((item) => ({
    ...item,
    displayLabel: LABEL_MAP[item.label] || item.label,
    color: COLOR_MAP[item.label] || "#CBD5E1",
    image: IMAGE_MAP[item.label],
  }));

  const chartData = useMemo(
    () => ({
      labels: dataSource.map((d) => d.displayLabel),
      datasets: [
        {
          data: dataSource.map((d) => d.value),
          backgroundColor: dataSource.map((d) => d.color),
          borderWidth: 0,
        },
      ],
    }),
    [dataSource]
  );

  const options = {
    cutout: "68%",
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {

        backgroundColor: "#1f2937",
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 14,
        cornerRadius: 10,
        displayColors: false,

        titleFont: {
          size: 14,
          weight: "600",

        },

        bodyFont: {
          size: 12,
          weight: "400",

        },

        footerFont: {
          size: 11,
        },

        callbacks: {
          title: (items) => items[0].label,
          label: (item) => [
            "Bookings",
            item.formattedValue,
          ],
        },
      },


    },
  };

    const dummyChartData = {
    datasets: [{
      label: "Vehicle Selection Distribution", data: [1], backgroundColor: ["#E0E0E0"], borderWidth: 0,
    },],
  };
 
  const dummyOptions = {
    cutout: "70%",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "#1f2937",
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 14,
        cornerRadius: 10,
        displayColors: false,
 
        titleFont: {
          size: 14,
          weight: "600",
        },
 
        bodyFont: {
          size: 12,
          weight: "400",
        },
 
        callbacks: {
          title: () => "", 
          label: () => "0\nBookings",
        },
      },
    },
  };
 

  return (
    <div className="vehicle-card">
      <h3 className="vehicle-title">Vehicle Selection Distribution</h3>

      <span className="total-badge">
        {totalCurrentMonth} Total Booking
      </span>

     <div className="donut-wrapper">
  {chartData?.datasets?.[0]?.data?.some(value => value > 0) ? (
    <Doughnut data={chartData} options={options} />
  ) : (
    <div>
      <Doughnut data={dummyChartData} options={dummyOptions} />
      <p className="text-center" style={{marginTop:"20px"}}>There are no bookings</p>
    </div>
  )}
</div>

      <div className="vehicle-legend">
        {dataSource.map((item) => {
          const percent = (
            (item.value / totalCurrentMonth) *
            100
          ).toFixed(1);

          return (
            <div key={item.label} className="legend-row">
              <div className="legend-left">
                <img
                  src={item.image}
                  alt={item.displayLabel}
                  className="vehicle-icon"
                />
                <span>{item.displayLabel}</span>
              </div>

              <div className="legend-right">
                <span>{percent}%</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransportDoughnutChart;
